import Layout from '@modules/layout/components/layout.vue';
import Permissions from '@security/permissions';

const PropertySettingListPage = () =>
  import('@modules/property-setting/components/property-setting-list-page.vue');
const PropertySettingFormPage = () =>
  import('@modules/property-setting/components/property-setting-form-page.vue');
const PropertySettingViewPage = () =>
  import('@modules/property-setting/components/property-setting-view-page.vue');
const PropertySettingImporterPage = () =>
  import('@modules/property-setting/components/property-setting-importer-page.vue');

export default [
  {
    name: '',
    path: '',
    component: Layout,
    meta: { auth: true },
    children: [
      {
        name: 'propertySetting',
        path: '/property-setting',
        component: PropertySettingListPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertySettingView,
        },
      },
      {
        name: 'propertySettingNew',
        path: '/property-setting/new',
        component: PropertySettingFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertySettingCreate,
        },
      },
      {
        name: 'propertySettingImporter',
        path: '/property-setting/import',
        component: PropertySettingImporterPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertySettingImport,
        },
      },
      {
        name: 'propertySettingEdit',
        path: '/property-setting/:id/edit',
        component: PropertySettingFormPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertySettingEdit,
        },
        props: true,
      },
      {
        name: 'propertySettingView',
        path: '/property-setting/:id',
        component: PropertySettingViewPage,
        meta: {
          auth: true,
          permission: Permissions.values.propertySettingView,
        },
        props: true,
      },
    ],
  },
];
